import type { ValueOf } from 'type-fest';

import type { DateFormat } from '@frontend/utils';

export type UpdateUserGroupRequestParams = {
  locator: string;
};

export const PREFERRED_UNIT_SYSTEMS = {
  METRIC: 'Metric',
  IMPERIAL: 'Imperial',
} as const;

export type PreferredUnitSystem = ValueOf<typeof PREFERRED_UNIT_SYSTEMS>;

export type PreferredDateFormat = DateFormat;

export type UpdateUserGroupRequestBody = {
  businessName?: string;
  creditCardCheckout?: boolean;
  defaultCreditCardsEnabledForAccounts?: boolean;
  defaultPaymentTermsForAccounts?: number;
  defaultPurchaseOrdersEnabledForAccounts?: boolean;
  isDiscountsEnabled?: boolean;
  isEnforceMfaOrSsoForShareRecipientsEnabled?: boolean;
  isNewDxfFeaturesEnabled?: boolean;
  leadTimeUnit?: string;
  preferredDateFormat?: PreferredDateFormat;
  preferredUnitSystem?: PreferredUnitSystem;
  standardLeadTimeTemplate?: number;
  taxRate?: number;
  quoteNumberPrefix?: string | null;
};

// TODO: add additional properties typing
export type UpdateUserGroupResponseBody = {
  businessName: string;
  creditCardCheckout: boolean;
  defaultCreditCardsEnabled_for_accounts: boolean;
  defaultPaymentTermsForAccounts: number;
  defaultPurchaseOrdersEnabledForAccounts: boolean;
  isDiscountsEnabled: boolean;
  isEnforceMfaOrSsoForShareRecipientsEnabled: boolean;
  leadTimeUnit: string;
  preferredDateFormat: PreferredDateFormat;
  preferredUnitSystem: PreferredUnitSystem;
  standardLeadTimeTemplate: number;
  taxRate: number;
  quoteNumberPrefix: string | null;
};
